import { M as MapyReviewButton$1, d as defineCustomElement$1 } from './mapy-review-button2.js';

const MapyReviewButton = MapyReviewButton$1;
const defineCustomElement = defineCustomElement$1;

export { MapyReviewButton, defineCustomElement };

//# sourceMappingURL=mapy-review-button.js.map